import { jsx as _jsx } from "react/jsx-runtime";
import { useStoreActions } from '~/store/store-context';
import { PracticeManagement } from '~/types/api.model';
import PMSetupPage from './PMSetupPage/PMSetupPage';
export const KarbonSetupPage = (param)=>{
    let { integration } = param;
    const { api, fetchKarbonItems } = useStoreActions();
    return /*#__PURE__*/ _jsx(PMSetupPage, {
        testId: "karbon-setup",
        pmName: PracticeManagement.Karbon,
        integration: integration,
        getItems: fetchKarbonItems,
        doDisconnect: api.karbon.disconnect,
        linkServiceTemplate: api.karbon.linkServiceTemplate,
        getServiceTemplateIntegratedIds: (template)=>template.integrations.karbonIntegratedIds()
    });
};
